import React, { useEffect , useState} from "react";
import { useResults, ElasticDocumentType } from "@usereactify/search";

export const InstantSearchCollections: React.FC = (props) => {
  const { results } = useResults();
  const { resultStats } = useResults(); 

  const [ collectionTitle, setCollectionTitle] = useState(""); 
  const [ collections, setCollections] = useState([]); 

  useEffect(() => {
    try {
      setCollectionTitle("collections");
      generateCollections();   
    }
    catch{}
  }, [props])

  const generateCollections = () => {
    const shopSettings = JSON.parse(document.querySelector("#shopify-setting-data")?.innerHTML as string);
    const collections = shopSettings.search_collection_list;
    setCollections(collections);
  }

  return (
    <>
      <h3>{collectionTitle}</h3>
      <ul>
        {collections.map((collection: any) => (
          <li>
            <a href={`/collections/${collection?.handle}`}>{collection?.title}</a>
          </li>
        ))}
      </ul>
    </>
  );
};
